
import request from '@/util/request';

// 价值分析
export const getValueAnalysis = (params, options) =>
    request.get('/api/v4ward/valueDataReported/getValueAnalysis', Object.assign({}, options, { params }));

// 成本评价
export const getCostEvaluation = (params, options) =>
    request.get('/api/v4ward/valueDataReported/getCostEvaluation', Object.assign({}, options, { params }));

// 创收
export const getCreateIncome = (params, options) =>
    request.get('/api/v4ward/valueDataReported/getCreateIncome', Object.assign({}, options, { params }));

// 满意度分析
export const getSatisfaction = (params, options) =>
    request.get('/api/v4ward/valueDataReported/getSatisfaction', Object.assign({}, options, { params }));

